import React, { Component } from "react";
import snippet2 from './data-forumsnippet2.js';

import './whatson.css';

class ForumSnippet2 extends Component {

  render() {
    return (
        <div className="snippet2">
            
        {snippet2.map(item =>
                    <a href={item.url}>
    
        <div key={item.objectID}>
        <h1>{item.title}</h1>
        <p><a href={item.url}>{item.data}</a></p>
        <br></br>
        <a href={item.url}><img src={item.imgurl} alt="snippet2"/></a>
        </div>
        </a>
            )}
        </div>
        );
}
}
  

export default ForumSnippet2;



// WEBPACK FOOTER //
// ./src/ForumSnippet2.js